import { render, staticRenderFns } from "./big-file.vue?vue&type=template&id=15716d0a&"
import script from "./big-file.vue?vue&type=script&lang=js&"
export * from "./big-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports